<template>
  <v-container fluid fill-height class="container-embed pa-0 ma-0" style="background-color: rgb(31, 46, 53) !important">
    <v-row no-gutters justify="center" style="height: 100%" dense>
      <v-col
        v-if="modiTitle || isClipOrganizer"
        cols="11"
        class="calendly-title text-center container-clip-title"
        :style="modiTitle || isClipOrganizer ? 'opacity: 1' : 'opacity: 0'"
      >
        <v-tooltip top color="#131b1e" :disabled="!modiTitle">
          <template v-slot:activator="{ on }">
            <v-text-field
              ref="titleTxtF"
              :readonly="!isClipOrganizer"
              v-model="modiTitle"
              :class="'tf-clip-' + (modiTitle ? 'title' : 'untitled') + (isClipOrganizer ? '-organizer' : '')"
              :placeholder="isClipOrganizer ? $t('enterTitle') : 'Untitled'"
              dark
              background-color="rgb(31, 46, 53)"
              hide-details
              flat
              solo
              @blur="saveTxtF"
              @keyup.enter="saveTxtF"
              v-on="on"
            ></v-text-field>
          </template>
          <span>
            {{ modiTitle ? modiTitle : isClipOrganizer ? $t('enterTitle') : 'Untitled' }}
          </span>
        </v-tooltip>
      </v-col>
      <v-col
        cols="12"
        align-self="start"
        class="content-text"
        :style="urlType !== 'calendly' && !modiTitle && !isClipOrganizer ? 'height: 100%' : 'height: auto'"
      >
        <iframe
          name="iframe"
          :id="urlType == 'calendly' ? 'calendlyIframeViewComponent' : 'iframeViewComponent'"
          :src="url"
          :class="urlType == 'calendly' ? 'embed-inline-widget' : 'embed-inline-widget'"
          frameborder="0"
          ref="iframeDom"
          loading="lazy"
          allowtransparency="true"
          v-on:load="endLoading()"
          :key="iframeKey"
          @load="isUrlLoadableInIframe()"
          :style="
            urlType !== 'calendly' && !modiTitle && !isClipOrganizer && $vuetify.breakpoint.width > 1263
              ? 'height: 100%'
              : ''
          "
        ></iframe>
        <!-- <div v-if="!isLoading && !isLoadable && !isExceptLoadable" class="iframe-btn-background">
          <v-btn class="iframe-btn text-truncate" :href="url" target="_blank" elevation="0" dark>
            {{ url }}
          </v-btn>
        </div> -->
        <div v-if="isLoading" class="iframe-loader-background">
          <v-progress-linear class="iframe-loader-progress" indeterminate dark height="5"></v-progress-linear>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { setClipUpdate } from '@/services/clipApi'
import { mapState } from 'vuex'
export default {
  components: {},
  data() {
    return {
      url: '',
      urlType: null,
      isLoading: false,
      iframeKey: 0,
      isLoadable: false,
      isExceptLoadable: true,
      modiTitle: null,
    }
  },
  created() {},
  mounted() {},
  updated() {},
  methods: {
    isUrlLoadableInIframe() {
      this.isLoadable = this.$refs.iframeDom.contentWindow.length ? true : false
    },
    endLoading() {
      this.isLoading = false
    },
    async setClipUpdate() {
      this.editingClip.clipTitle = this.modiTitle
      if (this.editingClip !== undefined && this.editingClip !== null && this.isClipOrganizer) {
        // Blur 등 현재 상태에서 업데이트인 경우
        // if (this.editingClip.clipNote !== this.clipNote || this.editingClip.clipTitle === this.clipTitle) {
        let clipIndex = this.totalSectionList[this.sectionIndex].clipList.findIndex(
          (clip) => clip.clipId === this.editingClip.clipId
        )
        if (clipIndex >= 0) {
          this.totalSectionList[this.sectionIndex].clipList[clipIndex].clipNote = this.editingClip.clipNote
          this.totalSectionList[this.sectionIndex].clipList[clipIndex].clipTitle = this.editingClip.clipTitle
          try {
            await setClipUpdate(
              this,
              this.$store.getters.selectedWsInfo.wsId,
              this.mtInfo.mtId,
              this.editingClip.clipId,
              this.editingClip.clipNote,
              this.editingClip.clipTitle
            )
          } catch (error) {
            console.log(error)
          } finally {
            // await this.$store.dispatch('setIsLoading', false)
          }
        }
        // }
      }
    },
    saveTxtF() {
      this.$store.dispatch('setEditingClip', this.currentClip)
      this.setClipUpdate()
      this.isNoteEdit = false
    },
  },
  computed: {
    mtInfo() {
      return this.$store.getters.currentMt
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    content() {
      return this.$store.getters.currentClip.textClip
    },
    isClipOrganizer() {
      let clipUploader =
        this.currentClip !== undefined && this.currentClip !== null ? this.currentClip.clipUploader : null
      if (clipUploader && clipUploader !== null && this.userInfo && this.userInfo !== null)
        return clipUploader.userId === this.userInfo.userId
      else return false
    },
    ...mapState({
      currentClip: (state) => {
        return state.clip.currentClip
      },
      mtInfo: (state) => {
        return state.auth.currentMt
      },
      userInfo: (state) => {
        return state.auth.userInfo && state.auth.userInfo !== null ? state.auth.userInfo : {}
      },
      wsInfo: (state) => {
        return state.auth.selectedWsInfo
      },
      sectionIndex: (state) => {
        return state.clip.sectionIndex
      },
      totalSectionList: (state) => {
        return state.clip.totalSectionList
      },
      clipIndex: (state) => {
        return state.clip.clipIndex
      },
      storeClipIndex: (state) => {
        return state.clip.clipIndex
      },
      editingClip: (state) => {
        return state.clip.editingClip
      },
    }),
  },
  watch: {
    currentClip: {
      immediate: true,
      deep: true,
      handler(val) {
        this.modiTitle = this.currentClip.clipTitle
        this.isExceptLoadable = false
        this.isLoading = true
        this.iframeKey += 1
        this.url = val.contentData.url

        if (this.url.indexOf('calendly.com') > -1) {
          this.urlType = 'calendly'
        } else if (this.url.indexOf('codepen.io') > -1) {
          this.urlType = 'codepen'
        } else if (this.url.indexOf('figma.com') > -1) {
          this.urlType = 'figma'
        } else {
          this.urlType = null
        }

        if (this.urlType == 'calendly') {
          this.isExceptLoadable = true
          // 기존 캘린들리 스크립트가 존재시 제거
          if (document.querySelector('script[tag="calendly"]')) {
            document
              .querySelector('script[tag="calendly"]')
              .parentNode.removeChild(document.querySelector('script[tag="calendly"]'))
          }
          let calendlyScript = document.createElement('script')
          calendlyScript.setAttribute('tag', 'calendly')
          calendlyScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js')
          document.head.appendChild(calendlyScript)
        } else if (this.urlType == 'codepen') {
          this.isExceptLoadable = true
          // codepen 임베드일때 유저가 pen 주소를 입력하면 embed 주소로 바꿔줘야함
          this.url = this.url.replace('/pen/', '/embed/')
        } else if (this.urlType == 'figma') {
          this.isExceptLoadable = true
          // figma 주소가 들어오면 embed 주소인지 판별 후 바꿔줘야 함
          if (this.url.indexOf('figma.com/embed?embed_host=share') < 0) {
            // embed 주소가 아니라 기본 주소가 들어오면
            let prefix = 'https://www.figma.com/embed?embed_host=share&url='
            this.url = this.url
              .replaceAll('%', '%25')
              .replaceAll(':', '%3A')
              .replaceAll('/', '%2F')
              .replaceAll('?', '%3F')
              .replaceAll('=', '%3D')
              .replaceAll('&', '%26')
            this.url = prefix.concat(this.url)
          }
        } else if (this.url.indexOf('appointment/rolltide') > -1) {
          this.isExceptLoadable = true
          // let rolltideScript = document.createElement('script')
          // rolltideScript.setAttribute('tag', 'rolltide')
          // rolltideScript.setAttribute(
          //   'src',
          //   'https://link.4sitehub.com/js/form_embed.js' + '?ts=' + new Date().getTime()
          // )
          // document.head.appendChild(rolltideScript)
        }
      },
    },
  },
}
</script>

<style scoped>
.container-embed {
  display: flex;
  background: #31434f;
  width: 100%;
  height: calc(100vh - 116px);
  align-items: center;
  justify-content: center;
}
@media (max-width: 959px) {
  .container-embed {
    height: calc(50vh);
  }
}
.content-text,
.content-avatar,
.content-name {
  color: #eee;
  font-weight: 500;
  text-align: center;
}
.content-text {
  display: flex;
  color: #eee;
  font-size: 1.8rem;
}
.content-name {
  color: rgb(150, 167, 175);
  font-size: 1.2rem;
  vertical-align: middle;
}
.calendly-title {
  position: relative;
  color: #eee;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -1px;
  z-index: 2;
  margin-top: 20px;
  height: 60px;
}
@media (max-width: 1263px) {
  .calendly-title {
    margin-top: 10px;
    height: 60px;
  }
}
@media (max-width: 725px) {
  .calendly-title {
    font-size: 25px;
    bottom: 0;
    height: 50px;
    margin-top: 0px;
  }
}
.calendly-inline-widget {
  display: flex;
  width: 100%;
  height: calc(100vh - 196px);
}
.embed-inline-widget {
  display: flex;
  width: 100%;
  height: calc(100vh - 196px);
}
@media (max-width: 959px) {
  .calendly-inline-widget {
    height: calc(50vh - 50px);
  }
  .embed-inline-widget {
    height: calc(50vh - 50px);
  }
}
.tf-clip-title,
.tf-clip-untitled,
.tf-clip-title-organizer,
.tf-clip-untitled-organizer {
  display: inline-block;
  width: 100%;
  font-size: 24px;
  font-weight: 600;
  border-radius: 0;
}
@media (max-width: 700px) {
  .tf-clip-title,
  .tf-clip-untitled,
  .tf-clip-title-organizer,
  .tf-clip-untitled-organizer {
    font-size: 16px;
  }
}
.container-clip-title >>> .tf-clip-title input::placeholder,
.container-clip-title >>> .tf-clip-untitled input::placeholder,
.container-clip-title >>> .tf-clip-title-organizer input::placeholder,
.container-clip-title >>> .tf-clip-untitled-organizer input::placeholder {
  color: white !important;
  opacity: 1;
  padding-top: 0;
  padding-bottom: 0;
  text-align: center;
}
.container-clip-title >>> .tf-clip-untitled input::placeholder,
.container-clip-title >>> .tf-clip-untitled-organizer input::placeholder {
  opacity: 0.5;
}
.container-clip-title >>> .tf-clip-title input,
.container-clip-title >>> .tf-clip-untitled input,
.container-clip-title >>> .tf-clip-title-organizer input,
.container-clip-title >>> .tf-clip-untitled-organizer input {
  color: white !important;
  opacity: 1;
  padding-top: 0;
  padding-bottom: 0;
  text-align: center;
}
.container-clip-title >>> .tf-clip-title .v-input__slot,
.container-clip-title >>> .tf-clip-untitled .v-input__slot,
.container-clip-title >>> .tf-clip-title-organizer .v-input__slot,
.container-clip-title >>> .tf-clip-untitled-organizer .v-input__slot {
  cursor: default;
}
.container-clip-title >>> .tf-clip-title input,
.container-clip-title >>> .tf-clip-untitled input {
  cursor: default;
}
.container-clip-title >>> .tf-clip-title-organizer input,
.container-clip-title >>> .tf-clip-untitled-organizer input {
  cursor: text;
}
.iframe-loader-progress,
.iframe-btn {
  width: 33.3%;
  position: absolute;
  left: 33.3%;
  top: 50%;
  z-index: 200;
  border-radius: 10px;
  transition: all 0.3s;
}
.iframe-btn {
  background-color: #161d21 !important;
  top: calc(50% - 50px);
  min-height: 100px !important;
  height: auto !important;
  padding: 20px !important;
}
.iframe-btn:hover {
  background-color: rgba(31, 46, 53, 1) !important;
}
.iframe-btn >>> .v-btn__content {
  font-size: 15px;
  font-weight: 600;
  white-space: normal;
  word-break: break-all;
  display: contents;
}
.iframe-loader-background,
.iframe-btn-progress {
  background-color: rgb(31, 46, 53);
  width: 100%;
  height: 100%;
  z-index: 1;
  position: absolute;
  top: 0;
  border-radius: 25px;
}
@media (max-width: 1263px) {
  .iframe-loader-progress,
  .iframe-btn {
    top: 50%;
  }
  .iframe-btn {
    width: 80%;
    left: 10%;
  }
  .iframe-btn >>> .v-btn__content {
    font-size: 13px;
    font-weight: 500;
  }
  .iframe-loader-background,
  .iframe-btn-progress {
    position: fixed;
  }
}
</style>
